import { PortalTarget } from 'portal-vue';
import { defineComponent, provide } from 'vue';
import { TheModal } from '@/app/overlay-orchestrator';
import { provideCityAndChanger } from '@/features/choice-apartment/lib/Injection';
import { usePortalApi } from '@/plugins/api/portal';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { ScrollUpButton } from '@/shared/ui';
import { AppFooter } from '@/widgets/Footer';
import { NotificationsContainer } from '@/widgets/Notifications';
export default defineComponent({
  name: 'CatalogApartmentLayout',
  components: {
    PortalTarget: PortalTarget,
    ScrollUpButton: ScrollUpButton,
    AppFooter: AppFooter,
    NotificationsContainer: NotificationsContainer,
    TheModal: TheModal
  },
  setup: function setup() {
    provide('$portalApi', usePortalApi());
    provide('$screen', useScreenPlugin());
    provideCityAndChanger();
  }
});